<template>
  <div class="form-bottom">
    <el-form-item
      prop="adName"
      style="margin-bottom: 0"
      :rules="[
        {
          required: true,
          message: '请输入计划名称',
          trigger: 'blur',
        },
      ]"
    >
      <div class="ad-name" style="margin-top: 56px">
        <p class="level-2">计划名称</p>
        <el-input
          class="t-input"
          type="text"
          size="small"
          placeholder="请输入计划名称，1-50个字符"
          v-model="form.adName"
          maxlength="50"
          show-word-limit
        >
        </el-input>
      </div>
    </el-form-item>
    <el-form-item
      prop="adGroup"
      :rules="[
        {
          required: true,
          message: '1~50个字，请正确输入',
          trigger: 'blur',
        },
      ]"
    >
      <div class="ad-group">
        <p class="level-2">
          广告组
          <el-popover placement="top" trigger="hover" width="280">
            <p style="font-size: 12px; line-height: 1.8">
              通过广告组管理计划，设置广告组日预算、启停组，快捷管理组内计划
            </p>
            <i class="el-icon-question" slot="reference"></i>
          </el-popover>
        </p>
        <el-input
          class="t-input"
          type="text"
          size="small"
          placeholder="请输入广告组名称，1-50个字符"
          v-model="form.adGroup"
          maxlength="50"
          show-word-limit
        >
        </el-input>
      </div>
    </el-form-item>

    <slot></slot>

    <div class="btns">
      <button class="btn s-btn" type="button" @click="handleRelease">
        发布计划
      </button>
      <button class="btn" type="button" @click="onCancel">取消</button>
    </div>

    <el-dialog
      title="提示"
      :visible.sync="show"
      width="30%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <span>确定要修改吗？确定后将清空已填写的信息</span>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="onClose">取 消</el-button>
        <el-button type="primary" size="small" @click="$router.go(-1)"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    form: Object,
    show: Boolean,
  },
  methods: {
    handleRelease() {
      this.$emit("onSubmit");
    },
    onClose() {
      this.$emit("onClose");
    },
    onCancel() {
      this.$emit("onCancel");
    },
  },
};
</script>

<style lang="less" scoped>
.form-bottom {
  .level-2 {
    margin-top: 28px;
    margin-bottom: 12px;
    line-height: 20px;
    font-weight: 600;
    font-size: 14px;
    color: #333;
  }
  .el-icon-question {
    margin-left: 3px;
    color: #d3d3d3;
    font-size: 16px;
    vertical-align: -1px;
    cursor: pointer;
  }
  ::v-deep .t-input {
    width: 400px;
    .el-input__inner {
      background-color: #f2f2f2;
    }
    .el-input__count-inner {
      background: #f2f2f2;
    }
  }
  .btns {
    margin-top: 80px;
    margin-bottom: 72px;
    .btn {
      width: 138px;
      height: 40px;
      color: #333;
      padding: 5px 16px;
      font-size: 14px;
      line-height: 22px;
      border-radius: 4px;
      background-color: #fff;
      border: 1px solid #999;
      user-select: none;
      &:hover {
        background-color: #edf1fd;
        border-color: #194ce5;
      }
      &.s-btn {
        margin-right: 10px;
        color: #fff;
        background-color: #194ce5;
        border-color: #194ce5;
        &:hover {
          background-color: #436dea;
          border-color: #436dea;
        }
      }
    }
  }
}
</style>